import _ from 'underscore';
import { edmCampaign } from '@bingads-webui/edm-campaign';
import { getBundleCountriesAndBundleLocationCriterions } from '@bingads-webui-campaign/hotel-common-targets';

export const getLocations = (cid, aid, search) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .Locations.get({
      servingChannel: 'LinkedIn',
      select: ['ParentLocations'],
      search,
    }).toPromise();

export const getDefaultLocation = (cid, aid, lcid = '1033') =>
  getBundleCountriesAndBundleLocationCriterions(cid, aid, lcid).then(({ bundleLocationCriterions }) => {
    const locationCriterion = _.chain(bundleLocationCriterions)
      .first()
      .get('Criterion.LocationCriterion')
      .value();

    return {
      Id: locationCriterion.LocationId,
      CountryCode: locationCriterion.CountryCode,
      Name: locationCriterion.Name,
      GeoPoint: {
        Latitude: locationCriterion.Latitude,
        Longitude: locationCriterion.Longitude,
      },
      Type: locationCriterion.Type,
    };
  });

